import React from "react";
import { Link } from "react-router-dom";
import classnames from "classnames";
import { Button, Col, Form, Input, Modal, Row, message, Alert } from "antd";
import { connect } from "react-redux";

import {
  deleteSubjectReasonRequest,
  deleteSubjectRequest,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import classes from "./PatientProfileForm.css";
import { withNamespaces } from "react-i18next";
import get from "lodash/get";
import { getPatientProfileDeletePermission } from "../../reducers/user/selectors";
import {withRouter} from "react-router";

const routes = require("../../routes.json");

class PatientProfileDeleteForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      deleteSubmitModal: false,
      isLoading: false,
      requestResult: {},
    };
  }

  componentDidMount() {}

  handleSubmit = async (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const { patientProfileDeletePermission } = this.props;

        if (patientProfileDeletePermission) {
          try {
            await deleteSubjectReasonRequest(this.props.subjectID, {
              reason: values.reason,
            });
            message.success(this.props.i18n.t("Saved"));
            this.setState({
              deleteSubmitModal: false,
            });
            this.props.onProfileDelete();
            setTimeout(() => {
              this.props.history.push(routes.admin.enrolments);
            }, 1000);
          } catch (e) {
            this.setState({
              requestResult: { type: "error", message: this.props.i18n.t("Error") },
            });
            if (get(e, "response.status") === 401) {
              this.props.logout();
            }
          }
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult, deleteSubmitModal } = this.state;
    const { getFieldDecorator } = this.props.form;

    return (
      <React.Fragment>
        <Button
          type="primary"
          size="large"
          htmlType="button"
          disabled={get(this.props, 'locked')}
          className={classes.deleteButton}
          onClick={() => {
            this.setState({ deleteSubmitModal: true });
          }}
        >
          {this.props.i18n.t("Deactivate")}
        </Button>

        {deleteSubmitModal && (
          <Modal
            title={this.props.i18n.t(
              "NamespacePatientProfileForm:Subject deactivation"
            )}
            visible={deleteSubmitModal}
            onOk={this.handleSubmit}
            onCancel={() => {
              this.setState({ deleteSubmitModal: false });
            }}
            confirmLoading={isLoading}
          >
            <p>
              {this.props.i18n.t(
                "NamespacePatientProfileForm:Confirm patient deactivate action"
              )}
            </p>
            <Form onSubmit={this.handleSubmit}>
              <Row gutter={12}>
                <Col>
                  <label>
                    <b>{this.props.i18n.t("Reason")}</b>
                    <Form.Item>
                      {getFieldDecorator("reason", {
                        rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      })(<Input.TextArea />)}
                    </Form.Item>
                  </label>
                </Col>
                {requestResult.type && (
                  <Col>
                    <Alert
                      message={requestResult.message}
                      type={requestResult.type}
                      className={classes.submitResult}
                    />
                  </Col>
                )}
              </Row>
            </Form>
          </Modal>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, props) => ({
  patientProfileDeletePermission: getPatientProfileDeletePermission(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "patientProfileDelete" })(
  withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(PatientProfileDeleteForm)))
);



// WEBPACK FOOTER //
// ./src/components/PatientProfileForm/PatientProfileDeleteForm.js